/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";

import * as Templates from "./index";

class Template extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        classNames: PropTypes.string,
        label: PropTypes.string,
        children: PropTypes.node.isRequired,
        errors: PropTypes.element,
        rawErrors: PropTypes.arrayOf(PropTypes.string),
        help: PropTypes.element,
        rawHelp: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        description: PropTypes.element,
        rawDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        hidden: PropTypes.bool,
        required: PropTypes.bool,
        readonly: PropTypes.bool,
        displayLabel: PropTypes.bool,
        fields: PropTypes.object,
        formContext: PropTypes.object,
        schema: PropTypes.object.isRequired,
        uiSchema: PropTypes.object
    };

    static defaultProps = {
        hidden: false,
        readonly: false,
        required: false,
        displayLabel: true,
        uiSchema: {}
    };

    renderTemplate(CustomTemplate) {
        return (<CustomTemplate {...this.props} />);
    }

    render() {
        let template = this.props.uiSchema["ui:template"] || this.props.schema["type"];
        if (template && Templates[template]) return this.renderTemplate(Templates[template]);
        return this.renderTemplate(Templates["standard"]);
    }
}

export default Template;
